module.exports = __webpack_public_path__ + "img/custom-icons.2a9e146e.svg";